export enum SCAPaymentEvent
{
    Ready = 1,
    Success = 2,
    Cancelled = 3,
    Declined = 4
}
